import { ApiClient } from "./api.ts";

export interface APIKey {
    id: string;
    name: string;
    prefix: string;
    scopes: string[];
    active: boolean;
    last_used_at?: string;
    created_at: string;
}

export class APIKeyService {
    private static instance: APIKeyService;
    private api = ApiClient.getInstance();

    private constructor() { }

    public static getInstance(): APIKeyService {
        if (!APIKeyService.instance) {
            APIKeyService.instance = new APIKeyService();
        }
        return APIKeyService.instance;
    }

    public async list(): Promise<APIKey[]> {
        return this.api.request<APIKey[]>(`/user/apikeys`) as Promise<APIKey[]>;
    }

    public async create(name: string, scopes: string[]): Promise<{ apiKey: APIKey, key: string }> {
        return this.api.request<{ apiKey: APIKey, key: string }>(`/user/apikeys`, {
            method: 'PUT',
            body: JSON.stringify({ name, scopes })
        }) as Promise<{ apiKey: APIKey, key: string }>;
    }

    public async revoke(id: string): Promise<void> {
        await this.api.request<void>(`/user/apikeys/${id}`, {
            method: 'DELETE'
        });
    }

    public async update(id: string, updates: { name?: string; active?: boolean }): Promise<void> {
        await this.api.request<void>(`/user/apikeys/${id}`, {
            method: 'PATCH',
            body: JSON.stringify(updates)
        });
    }
}
